import { z, isoZ } from 'my-zod'

//Note: this type is based off an xsd file provided by the GAME team
//There are several fields we can probably get more specific about later
//for example, changing string to enum or changing string to boolean
//but to play it safe, until we get more clarity from the business,
//we should just strictly follow the XSD definition for the payload

export const corporateFleetVehicleMessageBodyModel = z.object({
  Action: z.enum(['Add', 'Change']),
  VIN: z.string(),
  EIN: z.string().nullish(),
  Status: z.string().nullish(),
  Department: z
    .object({
      DepartmentNumber: z.string().nullish(),
      DepartmentGroupId: z.string().nullish()
    })
    .nullish(),
  Customer: z
    .object({
      CustomerNumber: z.string().nullish(),
      CustomerName: z.string().nullish(),
      CustomerBilled: z.string().nullish(),
      OrderNumber: z.string().nullish()
    })
    .nullish(),
  HoldStatus: z
    .object({
      HoldsExist: z.string().nullish(),
      NumberOfOpenHolds: z.number().nullish(),
      YLDHoldExists: z.string().nullish()
    })
    .nullish(),
  TrackingData: z
    .object({
      Site: z.string().nullish()
    })
    .nullish(),
  Comments: z
    .array(
      z
        .object({
          CommentNumber: z.string().nullish(),
          CommentSequence: z.string().nullish(),
          CommentText: z.string().nullish(),
          CommentTimestamp: z.string().nullish(),
          CommentUser: z.string().nullish()
        })
        .nullish()
    )
    .nullish(),
  User: z
    .object({
      Owner: z.string().nullish(),
      DelegatedUser: z.string().nullish(),
      ResponsibleUser: z.string().nullish(),
      ResponsibleUserTitle: z.string().nullish()
    })
    .nullish(),
  Details: z
    .object({
      ExemptionLabel: z.string().nullish(),
      BuildCode: z.string().nullish(),
      BuildIteration: z.string().nullish(),
      Certification: z
        .object({
          EffectivityFrom: z.string().nullish(),
          EffectivityTo: z.string().nullish()
        })
        .nullish(),
      Engine: z
        .object({
          EngineModel: z.string().nullish(),
          EngineSerialNumber: z.string().nullish()
        })
        .nullish(),
      InitialTrackingDate: z.string().nullish(),
      Label: z.string().nullish(),
      Model: z.string().nullish(),
      ModelDescription: z.string().nullish(),
      ModelYear: z.string().nullish(),
      NonSerialized: z.string().nullish(),
      PreProduction: z.string().nullish(),
      ProductLine: z.string().nullish(),
      ProdType: z.string().nullish(),
      ProducedDate: z.string().nullish(),
      ProjectNumber: z.string().nullish(),
      SalesFamily: z.string().nullish(),
      SalesFamilyDesc: z.string().nullish(),
      ShipmentNumber: z.string().nullish(),
      SNumber: z.string().nullish(),
      Competitor: z.string().nullish(),
      PreCertified: z.string().nullish(),
      Disposition: z.string().nullish(),
      Shippable: z.string().nullish()
    })
    .nullish()
})
export type corporateFleetVehicleMessageBodyModel = z.infer<typeof corporateFleetVehicleMessageBodyModel>

export const corporateFleetVehicleMessageLogModel = z.object({
  id: z.string(),
  batchId: z.string(),
  messageId: z.string(),
  vin: z.string(),
  body: corporateFleetVehicleMessageBodyModel,
  status: z.enum(['Received', 'Processed', 'Skipped']),
  successfullyProcessedDate: isoZ.instant().nullable(),
  receivedDate: isoZ.instant()
})

export type corporateFleetVehicleMessageLogModel = z.infer<typeof corporateFleetVehicleMessageLogModel>
